module.exports = __webpack_public_path__ + "static/gallery39-f07677c100a7931488e22c1e6ec911d1.jpg";